(() => {
  const bar = document.querySelector('.au-recipe-print--bar');
  if (bar && /FBAN|FBAV|Instagram|; wv\)/.test(navigator.userAgent)) bar.remove();
  else if (bar) {
    const sentinel = document.querySelector('.layout--bottom');
    if (sentinel) {
      const cta = bar.querySelector('.au-recipe-print--cta');
      new IntersectionObserver(
        ([entry]) => {
          const hidden = entry.isIntersecting;
          bar.setAttribute('aria-hidden', hidden ? 'true' : 'false');
          bar.toggleAttribute('inert', hidden);
          if (cta) cta.tabIndex = hidden ? -1 : 0;
        },
        { threshold: 0.1 }
      ).observe(sentinel);
    }
  }

  if (!document.body.hasAttribute('data-au-recipe-print-page')) return;

  document.addEventListener('click', (event) => {
    if (!event.target.closest('[data-au-print-trigger]')) return;
    window.print();
  });

  window.addEventListener('load', () => {
    if (document.fonts && document.fonts.ready) {
      document.fonts.ready.then(() => window.print());
    } else {
      window.print();
    }
  });
})();
